import { servicePointMemory } from "../../Objects/Memory/Memory"
import { ServicePoints } from "../../Objects/ServicePoint/ServicePoints"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"
import { useCallback } from "react"

export const useGetServicePoints = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetServicePoints = useCallback(async (onSuccess: () => void) => {
    enableLoad()
    try {
      const response = await GetRequest<ServicePoints[]>(API_ROUTES.SERVICE_POINT.GET_ALL)

      if (response.success) {
        const temp = response.data?.map((ss) => new ServicePoints(ss)) ?? []

        servicePointMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }, [disableLoad, enableLoad, setError, t])

  return {
    handleGetServicePoints,
  }
}
